import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function StockMovements() {
  const [movements, setMovements] = useState([]);
  const [locations, setLocations] = useState([]);
  const [filterLocation, setFilterLocation] = useState('');
  const [filterType, setFilterType] = useState('');
  const [search, setSearch] = useState('');

  const fetchMovements = async () => {
    const params = new URLSearchParams();
    if (filterLocation) params.set('location_id', filterLocation);
    if (filterType) params.set('movement_type', filterType);
    const res = await api.get('/api/inventory/movements?' + params.toString());
    setMovements(res.data);
  };

  useEffect(() => {
    api.get('/api/locations/').then(res => setLocations(res.data));
  }, []);

  useEffect(() => { fetchMovements(); }, [filterLocation, filterType]);

  const handleReverse = async (movement) => {
    if (!window.confirm(`"${movement.product_name}" için bu hareketi iptal etmek istediğinize emin misiniz? Ters yönde bir hareket oluşturulacak.`)) return;
    try {
      await api.post(`/api/inventory/movements/${movement.id}/reverse`);
      fetchMovements();
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
    }
  };

  const q = search.trim().toLowerCase();
  const filteredMovements = q
    ? movements.filter(m => (m.product_code || '').toLowerCase().includes(q) || (m.product_name || '').toLowerCase().includes(q))
    : movements;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-gray-800">Stok Hareket Geçmişi</h2>
        <Link to="/inventory" className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 font-medium text-sm">
          Envantere Dön
        </Link>
      </div>

      <div className="mb-4 flex items-center gap-3">
        <input
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="🔍 Ürün kodu veya adı ara..."
          className="border rounded px-3 py-2 text-sm w-72"
        />
        <select value={filterLocation} onChange={e => setFilterLocation(e.target.value)} className="border rounded px-3 py-2 text-sm">
          <option value="">Tüm Depolar</option>
          {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
        </select>
        <select value={filterType} onChange={e => setFilterType(e.target.value)} className="border rounded px-3 py-2 text-sm">
          <option value="">Tüm Hareketler</option>
          <option value="in">Giriş</option>
          <option value="out">Çıkış</option>
        </select>
        <span className="text-sm text-gray-500 ml-auto">{filteredMovements.length} hareket</span>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Tarih</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Ürün</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Depo</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Tür</th>
              <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">Miktar</th>
              <th className="text-left px-4 py-3 text-sm font-medium text-gray-500">Neden / Not</th>
              <th className="text-right px-4 py-3 text-sm font-medium text-gray-500">İşlemler</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {filteredMovements.map(m => (
              <tr key={m.id} className={`hover:bg-gray-50 ${m.is_reversed ? 'opacity-50' : ''}`}>
                <td className="px-4 py-3 text-gray-600 text-sm">{m.movement_date}</td>
                <td className="px-4 py-3">
                  <div className="font-medium text-gray-800">{m.product_name}</div>
                  <div className="text-xs text-gray-500 font-mono">{m.product_code}</div>
                </td>
                <td className="px-4 py-3 text-gray-600">{m.location_name}</td>
                <td className="px-4 py-3">
                  {m.movement_type === 'in' ? (
                    <span className="bg-green-50 text-green-700 text-xs px-2 py-1 rounded font-medium">Giriş</span>
                  ) : (
                    <span className="bg-red-50 text-red-700 text-xs px-2 py-1 rounded font-medium">Çıkış</span>
                  )}
                  {m.is_reversed && <span className="ml-1 bg-gray-100 text-gray-500 text-xs px-2 py-1 rounded font-medium">İptal Edildi</span>}
                  {m.reverses_movement_id && <span className="ml-1 bg-orange-50 text-orange-600 text-xs px-2 py-1 rounded font-medium">İptal Hareketi</span>}
                </td>
                <td className="px-4 py-3 text-right font-medium text-gray-800">{m.quantity} {m.unit}</td>
                <td className="px-4 py-3 text-gray-600 text-sm">
                  {m.reason || '-'}
                  {m.note && <div className="text-xs text-gray-400">{m.note}</div>}
                </td>
                <td className="px-4 py-3 text-right">
                  {!m.is_reversed && !m.reverses_movement_id && (
                    <button onClick={() => handleReverse(m)} className="text-red-500 hover:text-red-700 font-medium text-sm">İptal Et</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filteredMovements.length === 0 && (
          <div className="text-center py-12 text-gray-400">{movements.length === 0 ? 'Henüz stok hareketi kaydedilmemiş' : 'Aramayla eşleşen hareket bulunamadı'}</div>
        )}
      </div>
    </div>
  );
}
